export default class ItemNumber {
  /**
  ** 実行
  ** @constructor
  **/      
  constructor() {
    this.getParam()
    this.bindEvent()
  }

  /**
  ** 各種要素を取得している
  ** @getParam
  **/      
  getParam() {
    this.ItemCont = document.querySelectorAll(`[data-module='item-deco-cnt']`)
    this.ItemContArray = Array.prototype.slice.call(this.ItemCont)
    this.Item = document.querySelectorAll(`[data-module='item-deco-cnt'] > .deco-item`)
    this.ItemArray = Array.prototype.slice.call(this.Item)
  }


  /**
  ** アイテムにindex番号に基づいた番号をinsertしていく
  ** @bindEvent
  **/
  bindEvent() {

    Array.prototype.forEach.call(this.ItemContArray, (decoCont)=> {

      let
        decoElem = decoCont.getElementsByClassName('deco-item'),
        ArraydecoElem = Array.prototype.slice.call(decoElem),
        initNum = 1

      Array.prototype.forEach.call(ArraydecoElem,(ele)=> {
  
        let num = `<span class="number">${initNum ++}</span>`

        ele.insertAdjacentHTML('afterbegin',num)

        if(initNum === 2)
          ele.children[0].classList.add('is-01')
        else if( initNum === 3)
          ele.children[0].classList.add('is-02')
        else if (initNum === 4)
          ele.children[0].classList.add('is-03')
      })
    })
  }
}